export const WORK_TYPES = ['근무', '휴무', '마감', '연차', '반차', '경조', 'A', 'A1', 'B', 'C'];

export const SUMMARY_COLUMNS = ['마감', '휴무', '연차'];

export const DAILY_SUMMARY_ROWS = ['휴무자', '연차자', '마감자', '사무실 출근자', '출근자', '총원'];
